// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import GridsMatchGridInfoContainer from '../../containers/grid/GridsMatchGridInfoContainer';
import type { GridsCheckType } from '../../types';
import CheckBox from '../buttons/CheckBox';
import CheckBoxBasket from '../buttons/CheckBoxBasket';
import { infoButtonCss } from '../buttons/InfoButton';

const Line = styled.div`
  position: relative;
  padding: 0 0.6em;
  margin: 0 0 2px 0;

  ${Target.__MOBILE__
    ? css`
        display: flex;
        align-items: center;
        justify-content: center;
      `
    : undefined}

  ${({ $isCancelled, $isLive, $isBasket, theme }) => css`
    opacity: ${$isCancelled ? 0.4 : 1};
    background: ${$isLive ? theme.grids.colors.darkgrey4 : 'none'};

    ${!$isBasket
      ? css`
          &:nth-of-type(2n) {
            background: ${$isLive ? theme.grids.colors.darkgrey4 : theme.grids.colors.darkgrey1};
          }
        `
      : undefined}
  `}
`;

const BorderLive = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 2px;
  background: ${({ theme }) => theme.grids.colors.yellow};
`;

const InnerWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: ${({ $isBasket }) => (Target.__MOBILE__ || $isBasket ? '0' : '0.4em 0')};
`;

const Competitor = styled.span`
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1em;
  line-height: 1.2;
  color: ${({ $isBasket, theme }) => ($isBasket ? theme.grids.colors.black : theme.grids.colors.lightgrey)};
`;

const Competitor1 = styled(Competitor)`
  margin-right: 0.5em;
  text-align: right;
  width: 30%;
  min-width: 30%;
`;

const Competitor2 = styled(Competitor)`
  text-align: left;
`;

const CheckBoxes = styled.span`
  display: flex;
  text-align: center;
  white-space: nowrap;
  width: 40%;
  justify-content: space-evenly;
  margin: 0.4em 0;
`;

const Right = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 30%;
  min-width: 30%;
  margin-left: 0.5em;
`;

const TutoInfo = styled.p`
  ${infoButtonCss}
`;

type Check = {
  typeCheck: GridsCheckType;
  isChecked: boolean;
  isCheckedButNoBase: boolean;
  hasOccured?: boolean;
};

type GridsGridLineProps = {
  className?: string;
  matchIndex: number;
  isBasket?: boolean;
  isCancelled?: boolean;
  competitor1: string;
  competitor2: string;
  onCheckBox?: (matchIndex: number, typeCheck: GridsCheckType) => void;
  checks: Array<Check>;
  matchId: number;
  showInfo?: boolean;
  isLive?: boolean;
  isWin?: boolean;
  isLost?: boolean;
  isTuto?: boolean;
};

const GridsGridLine = ({
  className,
  matchIndex,
  isBasket,
  isLive,
  isCancelled,
  competitor1,
  competitor2,
  onCheckBox,
  checks,
  showInfo,
  matchId,
  isWin,
  isLost,
  isTuto = false,
}: GridsGridLineProps) => {
  const CheckBoxComponent = useMemo(() => (isBasket ? CheckBoxBasket : CheckBox), [isBasket]);
  const finalClassName = className ? `${className} grid-line` : 'grid-line';

  return (
    <Line className={finalClassName} $isCancelled={isCancelled} $isLive={isLive} $isBasket={isBasket}>
      <InnerWrap $isBasket={isBasket}>
        {isLive ? <BorderLive /> : null}
        <Competitor1 $isBasket={isBasket}>{competitor1}</Competitor1>
        <CheckBoxes isBasket={isBasket}>
          {checks.map(({ typeCheck, isChecked, isCheckedButNoBase, hasOccured }) => (
            <CheckBoxComponent
              key={typeCheck}
              typeCheck={typeCheck}
              matchIndex={matchIndex}
              isChecked={isChecked}
              isCheckedButNoBase={isCheckedButNoBase}
              handleClick={onCheckBox}
              hasOccured={hasOccured}
            />
          ))}
        </CheckBoxes>
        <Right>
          <Competitor2 $isBasket={isBasket}>{competitor2}</Competitor2>
          {showInfo ? <GridsMatchGridInfoContainer matchId={matchId} isWin={isWin} isLost={isLost} /> : null}
          {isTuto ? <TutoInfo>i</TutoInfo> : null}
        </Right>
      </InnerWrap>
    </Line>
  );
};

export default GridsGridLine;
